











































import { Component, Vue, Prop } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';
import formatNumber from '@/shared/filters/format-number';
import transitionServices from '@/services/transition-services';

@Component
export default class ListTransition extends Vue {
    @Prop({default: {}})
    private listItem: any;
    @Prop({default: {}})
    private pageSettings: any;

    private eventEmit = {
        eventReloadOrder: 'eventReloadOrder',
        eventCheckALl: 'eventCheckALl'
    };

    get isDepositSystem() {
        return APP_CONFIG.system_type !== 'order';
    }

    private transformNumb(value: number, format: string) {
        if (!(value > 0)) {
            return '0';
        }
        return formatNumber(value, format);
    }

    private async onOrderNoteChange(item: any) {
        const dataRequest = {
            Type: 'transaction',
            OrderNote: item.OrderNote
        };
        const result = await transitionServices.updateDetail(item.ID, dataRequest);
        if (result && result.status === 200 && result.data.status === 200) {
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: 'Update mã bill thành công!',
            });
        } else {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Có lỗi trong quá trình xử lý dữ liệu!',
            });
        }
    }
}
